/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';

@Injectable({ providedIn: 'root' })
export class IndicatorService {
    constructor(
        private i18nService: I18nService,
    ) {}

    getIndicatorNameAndUnit(id: number): {
        name: string;
        unit: string;
    } {
        const key = `monitor.performance_term_indicator_${id}`;
        let name: string = this.i18nService.get(key);

        if (name === key) {
            name = this.i18nService.get('monitor.performance_term_indicator_unknow');
        }

        const unitMatch = name.match(/\(.*\)+/g);
        let unit = '';

        if (unitMatch) {
            unit = unitMatch[0].substring(1, unitMatch[0].length - 1);
            name = name.replace(unitMatch[0], '');
        }
        return { name, unit };
    }
}
